import React, {MouseEvent, useState} from "react";
import { ADD_NEW_DOMAIN_END_POINT } from "../../../../config/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { api, getToken} from "../../../../services/apis/auth-api/apiUrl";
import { AxiosError } from "axios";
import { jdlButtonProps } from "../../../../utils/types";

const AddDomainButton : React.FC<jdlButtonProps> = ({inputName, onSubmit, onClear}) => {

    const [loading, setLoading] = useState<boolean>(false);
    
    function saveDomain (e : MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        if(inputName === '') return onSubmit({success : false, message : 'Please insert domain name.'})
        setLoading(true);
        setTimeout(async()=>{
            try{
                await api.post(ADD_NEW_DOMAIN_END_POINT, {
                    domain_name : inputName
                },{
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setLoading(false);
                onSubmit({
                    success : true,
                    message : 'New Domain added!'
                })
                onClear();
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401){
                    onSubmit({
                        success : false,
                        message : 'Unauthorized access!'
                    })
                }else{
                    onSubmit({
                        success : false,
                        message : 'An error occured!'
                    })
                }
                setLoading(false);
            }
        },500);
    }


    return (
        <div className="input-container">
            {loading ? (
                <button type="button" disabled className='button button-disabled'>
                    <FontAwesomeIcon className='animate-spin' icon={faSpinner} />  Processing....
                </button>
            ) : (
                <button type="button" onClick={saveDomain} className="button button-vcc-primary text-md">
                    Add Domain
                </button>
            )}
        </div>
    );
}

export default AddDomainButton;